var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg12494",
    viewBox: "0 0 300 165.30382",
    height: 165.30382,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12496"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath12171",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12173",
    d: "m 55.36,702.312 98.302,0 0,53.869 -98.302,0 0,-53.869 z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-291.84746,-593.15508)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12167",
    transform: "matrix(3.0314991,0,0,-3.0314991,125.02367,2886.5171)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath12171)",
    id: "g12169"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.36,702.6114)",
    id: "g12175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12177",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 2.203,0 0,4.374 c 0,0.779 0,1.74 0.399,2.303 0.397,0.612 1.11,0.811 1.508,0.811 1.856,0 1.856,-2.188 1.856,-2.948 l 0,-4.54 2.202,0 0,4.97 c 0,0.714 0,2.253 -0.844,3.263 C 6.563,9.162 5.352,9.512 4.558,9.512 3.165,9.512 2.403,8.747 2.039,8.399 l 0,0.798 L 0,9.197 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.5474,706.2231)",
    id: "g12179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12181",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.063,0.297 0.132,0.679 0.132,1.109 0,2.318 -1.84,4.841 -4.756,4.841 -2.834,0 -4.838,-2.389 -4.838,-4.989 0,-2.683 2.121,-4.872 4.855,-4.872 2.154,0 3.909,1.539 4.44,3.197 l -2.321,0 c -0.413,-0.762 -1.141,-1.175 -2.119,-1.175 -1.574,0 -2.436,1.292 -2.536,1.889 L 0,0 Z m -7.209,1.773 c 0.414,1.707 1.79,2.154 2.602,2.154 1.094,0 2.236,-0.679 2.485,-2.154 l -5.087,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.5066,702.6114)",
    id: "g12183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12185",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 1.356,0 1.741,5.964 0.032,0 L 4.854,0 l 1.358,0 3.363,9.197 -2.352,0 -1.692,-5.618 -0.032,0 -1.493,5.618 -1.754,0 -1.508,-5.618 -0.033,0 -1.673,5.618 -2.353,0 L 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.3468,702.6114)",
    id: "g12187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12189",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 2.02,0 0,1.11 c 0.545,-0.614 1.327,-1.409 3.1,-1.409 3.362,0 4.572,3.098 4.572,4.939 0,2.433 -1.822,4.872 -4.622,4.872 -1.028,0 -2.106,-0.383 -2.868,-1.146 l 0,3.895 L 0,12.261 0,0 Z m 2.069,4.721 c 0,1.342 1.044,2.767 2.734,2.767 1.393,0 2.686,-1.075 2.686,-2.867 0,-1.787 -1.21,-2.899 -2.652,-2.899 -1.292,0 -2.768,0.961 -2.768,2.999"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.3256,711.808)",
    id: "g12191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12193",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -2.023,0 0,-1.163 -0.033,0 c -0.067,0.134 -1.178,1.479 -3.048,1.479 -2.551,0 -4.607,-2.039 -4.607,-4.858 0,-3.064 2.105,-4.954 4.475,-4.954 1.158,0 2.518,0.615 3.213,1.439 l 0,-1.14 2.023,0 L 0,0 Z m -2.087,-4.576 c 0,-1.706 -1.162,-2.898 -2.687,-2.898 -1.573,0 -2.734,1.276 -2.734,2.833 0,1.375 0.928,2.932 2.734,2.932 1.31,0 2.687,-0.96 2.687,-2.867"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path12195",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 113.7,714.872 -2.203,0 0,-12.261 2.203,0 0,12.261 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.0712,711.808)",
    id: "g12197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12199",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -2.021,0 0,-1.163 -0.034,0 c -0.067,0.134 -1.178,1.479 -3.048,1.479 -2.554,0 -4.607,-2.039 -4.607,-4.858 0,-3.064 2.105,-4.954 4.474,-4.954 1.159,0 2.517,0.615 3.215,1.439 l 0,-1.14 2.021,0 L 0,0 Z m -2.088,-4.576 c 0,-1.706 -1.159,-2.898 -2.684,-2.898 -1.575,0 -2.734,1.276 -2.734,2.833 0,1.375 0.928,2.932 2.734,2.932 1.309,0 2.684,-0.96 2.684,-2.867"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.2441,702.6114)",
    id: "g12201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12203",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 2.202,0 0,4.374 c 0,0.779 0,1.74 0.399,2.303 0.397,0.612 1.112,0.811 1.508,0.811 1.855,0 1.855,-2.188 1.855,-2.948 l 0,-4.54 2.205,0 0,4.97 c 0,0.714 0,2.253 -0.847,3.263 C 6.56,9.162 5.352,9.512 4.556,9.512 3.163,9.512 2.403,8.747 2.037,8.399 l 0,0.798 L 0,9.197 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.2422,705.6097)",
    id: "g12205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12207",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.581,-0.928 -1.308,-1.276 -2.037,-1.276 -1.659,0 -2.768,1.309 -2.768,2.883 0,1.889 1.326,2.883 2.667,2.883 1.359,0 1.874,-0.878 2.138,-1.341 l 2.487,0 c -0.945,2.834 -3.466,3.365 -4.625,3.365 -2.535,0 -4.87,-2.058 -4.87,-4.872 0,-3.05 2.532,-4.939 4.888,-4.939 2.154,0 3.859,1.243 4.607,3.297 L 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.5302,706.2231)",
    id: "g12209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12211",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.065,0.297 0.131,0.679 0.131,1.109 0,2.318 -1.838,4.841 -4.754,4.841 -2.834,0 -4.839,-2.389 -4.839,-4.989 0,-2.683 2.121,-4.872 4.855,-4.872 2.153,0 3.911,1.539 4.44,3.197 l -2.319,0 c -0.415,-0.762 -1.142,-1.175 -2.121,-1.175 -1.575,0 -2.436,1.292 -2.533,1.889 L 0,0 Z m -7.208,1.773 c 0.415,1.707 1.789,2.154 2.601,2.154 1.095,0 2.237,-0.679 2.485,-2.154 l -5.086,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.8631,733.0946)",
    id: "g12213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12215",
    style: {
      fill: "#444",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -2.945,-5.086 -16.301,0.917 1.632,2.833 L 0,0 Z m 11.784,16.206 1.477,-5.613 -23.13,1.52 1.631,2.832 20.022,1.261 z m -15.334,6.88 13.539,-0.01 1.022,-3.838 -16.19,1.016 1.629,2.832 z m -1.19,-31.335 -2.351,-4.042 -16.843,-0.018 1.631,2.831 17.563,1.229 z m 29.571,10.905 -4.077,-7.067 3.883,0 c 1.799,0 5.023,0.898 6.015,3.46 0.919,2.381 -0.77,3.61 -1.949,3.61 L 24.831,2.656 Z m 3.888,6.76 3.387,0.021 c 2.254,0.012 4.605,1.043 5.465,3.135 0.793,1.941 -0.273,3.594 -1.686,3.588 l -3.276,0.004 -3.89,-6.748 z m -15.331,1.177 3.42,5.933 11.575,0.743 0.404,0.72 -10.707,0.749 2.504,4.348 19.856,0.001 c 6.106,0 10.623,-2.183 8.867,-8.603 C 48.779,12.539 46.297,7.643 39.018,5.592 40.563,5.408 44.411,3.703 43.748,-0.717 42.57,-8.555 32.422,-12.286 26.777,-12.288 l -23.442,-0.011 -1.155,4.535 12.278,0.866 0.417,0.718 -13.317,0.811 -1.435,5.376 18.949,1.106 0.412,0.712 -34.043,2.148 1.631,2.831 36.644,2.379 0.415,0.713 -10.743,0.697"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBalance);
export default __webpack_public_path__ + "static/media/new-balance.d369c6f161f1b03e366ee312b818096c.svg";
export { ForwardRef as ReactComponent };